import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoordinatedAirportDataListComponent } from './component/coordinated-airport-data-list/coordinated-airport-data-list.component';
import { AirportDataListComponent } from './component/airport-data-list/airport-data-list.component';
import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownAirportSelectComponent } from './component/dropdown-airport-select/dropdown-airport-select.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@app/core/core.module';

@NgModule({
  declarations: [
    CoordinatedAirportDataListComponent,
    AirportDataListComponent,
    DropdownAirportSelectComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  exports: [CoordinatedAirportDataListComponent, AirportDataListComponent, DropdownAirportSelectComponent]
})
export class AirportModule { }
